import InlineReplacement from './base/inline-replacement';
export default InlineReplacement.extend().reopenClass({
  delimiter: /(^|\s)[^\s]*$/,
  tryReplacementWithIndex(block) {
    this.tryReplacement(block);
  },
  tryReplacement(block, mutationResult) {
    if (block.get('config.markdownLinks')) {
      let regex = new RegExp(/\[(.+?)\]\((.+?)(?:\s.*?)?\)/g);
      let captureGroupMappings = ['text', 'href'];
      this._doInlineReplacement(block, regex, 'anchor', captureGroupMappings, mutationResult);
    }
  }
});